import { defineMessages } from "react-intl";

export const messages = defineMessages({
  unverifiedLabel: {
    id: "userListItemAvatar.unverified.label",
    defaultMessage: "Unverified",
    description: "label for unverified users",
  },
});
